export default "__VITE_ASSET__DUoptziJ__"